import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from '@mui/material';

interface Props {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

export const DeletePublicationDialog = ({
    open,
    onClose,
    onConfirm,
}: Props) => (
    <Dialog open={open} onClose={onClose}>
        <DialogTitle>Remove publication</DialogTitle>
        <DialogContent>
            <DialogContentText>
                Remove this publication? Other dates for this gift are kept. If
                it is the only one, the gift is no longer live or shown in the
                CMS, but players who already claimed it keep it.
            </DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button onClick={onClose}>Cancel</Button>
            <Button color="error" variant="contained" onClick={onConfirm}>
                Remove
            </Button>
        </DialogActions>
    </Dialog>
);
